export enum EntitetStatus {
    Uaendret = 0,
    Tilfoejet = 1,
    Aendret = 2,
    Slettet = 3
}
